(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Core references
    this.header = document.querySelector('.section-header');     // outer header section wrapper
    this.headerWrapper = this;                                   // <sticky-header> element itself

    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();

    // ---------- Only run overlay setup if on home page ----------
    const isHome = window.location.pathname === '/' || window.location.pathname.endsWith('/index.html');
    if (isHome) {
      const headerSection = this.header?.closest('.shopify-section') || null;
      let firstSectionCandidate = headerSection?.nextElementSibling || null;
      if (!(firstSectionCandidate && firstSectionCandidate.classList?.contains('shopify-section'))) {
        firstSectionCandidate =
          document.querySelector('section.shopify-section.section') ||
          document.querySelector('section.shopify-section') ||
          document.querySelector('.shopify-section');
      }
      this.firstSection = firstSectionCandidate || null;

      this.updateOverlayThreshold = this.updateOverlayThreshold?.bind(this) || this.updateOverlayThreshold.bind(this);
      this.updateOverlayThreshold(); // computes this.overlayThreshold

      if (this.headerWrapper) {
        this.headerWrapper.classList.toggle('start-absolute', (window.scrollY || 0) < (this.overlayThreshold || 0));
      }

      window.addEventListener('resize', this.updateOverlayThreshold);
      document.addEventListener('shopify:section:load', this.updateOverlayThreshold);
    }
  }

  setHeaderHeight() {
    if (this.header) {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);

    window.removeEventListener('resize', this.updateOverlayThreshold);
    document.removeEventListener('shopify:section:load', this.updateOverlayThreshold);
  }

  createObserver() {
    if (!this.header) return;
    const observer = new IntersectionObserver((entries, obs) => {
      this.headerBounds = entries[0].intersectionRect;
      obs.disconnect();
    });
    observer.observe(this.header);
  }

  // --- NEW: recompute the absolute Y of the bottom of the first section and toggle state immediately
  updateOverlayThreshold() {
    if (!this.firstSection) {
      this.overlayThreshold = 0;
    } else {
      const rect = this.firstSection.getBoundingClientRect();
      this.overlayThreshold = (window.scrollY || window.pageYOffset || 0) + rect.bottom;
    }
    if (this.headerWrapper) {
      this.headerWrapper.classList.toggle('start-absolute', (window.scrollY || 0) < (this.overlayThreshold || 0));
    }
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // --- NEW: toggle overlay at scroll time
    if (this.headerWrapper && typeof this.overlayThreshold === 'number') {
      const withinFirstSection = scrollTop < this.overlayThreshold;
      this.headerWrapper.classList.toggle('start-absolute', withinFirstSection);
    }

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach((disclosure) => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal?.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
